import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const Col = (props) => {
  const {
    xs,
    xsOffset,
    xsPull,
    xsPush,
    sm,
    smOffset,
    smPull,
    smPush,
    md,
    mdOffset,
    mdPull,
    mdPush,
    lg,
    lgOffset,
    lgPull,
    lgPush,
    xl,
    xlOffset,
    xlPull,
    xlPush,
    className,
    children,
    style,
  } = props

  const componentClass = classNames({
    [`col-xs-${xs}`]: xs,
    [`col-xs-offset-${xsOffset}`]: xsOffset,
    [`col-xs-pull-${xsPull}`]: xsPull,
    [`col-xs-push-${xsPush}`]: xsPush,
    [`col-sm-${sm}`]: sm,
    [`col-sm-offset-${smOffset}`]: smOffset,
    [`col-sm-pull-${smPull}`]: smPull,
    [`col-sm-push-${smPush}`]: smPush,
    [`col-md-${md}`]: md,
    [`col-md-offset-${mdOffset}`]: mdOffset,
    [`col-md-pull-${mdPull}`]: mdPull,
    [`col-md-push-${mdPush}`]: mdPush,
    [`col-lg-${lg}`]: lg,
    [`col-lg-offset-${lgOffset}`]: lgOffset,
    [`col-lg-pull-${lgPull}`]: lgPull,
    [`col-lg-push-${lgPush}`]: lgPush,
    [`col-xl-${xl}`]: xl,
    [`col-xl-offset-${xlOffset}`]: xlOffset,
    [`col-xl-pull-${xlPull}`]: xlPull,
    [`col-xl-push-${xlPush}`]: xlPush,
    [className]: className,
  })

  const newProps = {
    className: componentClass,
    children,
  }

  if (style) {
    newProps.style = style
  }

  return props.reference ? (
    <section ref={props.reference} {...newProps} />
  ) : (
    <section {...newProps} />
  )
}

Col.propTypes = {
  xs: PropTypes.number,
  xsOffset: PropTypes.number,
  xsPull: PropTypes.number,
  xsPush: PropTypes.number,
  sm: PropTypes.number,
  smOffset: PropTypes.number,
  smPull: PropTypes.number,
  smPush: PropTypes.number,
  md: PropTypes.number,
  mdOffset: PropTypes.number,
  mdPull: PropTypes.number,
  mdPush: PropTypes.number,
  lg: PropTypes.number,
  lgOffset: PropTypes.number,
  lgPull: PropTypes.number,
  lgPush: PropTypes.number,
  xl: PropTypes.number,
  xlOffset: PropTypes.number,
  xlPull: PropTypes.number,
  xlPush: PropTypes.number,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  style: PropTypes.object,
  reference: PropTypes.any,
}

export default Col
